import { sessionModel } from "entities/session";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import BE1 from "assets/BackgroundElTop.png";
import BE2 from "assets/BackgroundElBottom.png";
import Logo from "assets/Logo.svg";
import LogoSmall from "../../../assets/LogoSmall.svg";
import { PATH_LIST, PATH_PAGE } from "shared/lib/react-router";
import Am from "../../../assets/Armenia.svg";
import Ru from "../../../assets/Russia.svg";
import US from "../../../assets/US.svg";
import { useTranslation } from "react-i18next";
import GoBackButton from "shared/ui/back-button";
import { useCallback, useEffect } from "react";
import { sircapApi } from "shared/api/sircap";

const domain = process.env.REACT_APP_COOKIE_DOMAIN;

export function MainLayout() {
  return (
    <div
      className={`main-layout ${
        location.pathname === PATH_LIST.accountHasBeenCreated &&
        "acc-created-layout"
      }`}
    >
      <Outlet />
    </div>
  );
}
